import React, { useEffect, useState } from 'react';
import './MesFactures.css';
import { FaFileInvoiceDollar, FaCalendarAlt, FaEuroSign, FaDollarSign, FaCheckCircle, FaTimesCircle, FaHourglassHalf, FaReceipt, FaHome, FaEnvelope, FaPhone } from 'react-icons/fa';
import { useLanguage } from '../i18n/LanguageContext';
import { getApiBase, getAuthServerBase } from '../utils/runtime';
import { formatCareLabel } from '../care/labels';

const AUTH_SERVER = getAuthServerBase();
const API_BASE = getApiBase();

const MesFactures = () => {
  const { isEnglish } = useLanguage();
  const [user, setUser] = useState(null);
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    fetch(`${AUTH_SERVER}/me`, { credentials: 'include' })
      .then(res => res.ok ? res.json() : Promise.reject())
      .then(data =>
        fetch(`${API_BASE}/users/email/${data.email}`)
      )
      .then(res => res.json())
      .then(profile => {
        if (!profile?.user_id) throw new Error('Profile is missing an ID');
        setUser(profile);
        return fetch(`${API_BASE}/patients/${profile.user_id}/invoices`);
      })
      .then(res => res.json())
      .then(data => {
        if (!Array.isArray(data)) throw new Error('Invalid response: expected an array');
        setInvoices(data);
      })
      .catch(err => console.error('Error loading invoices:', err));
  }, []);

  if (!user) return <p className="invoices-loading">{isEnglish ? 'Loading invoices...' : 'Chargement des factures...'}</p>;

  return (
    <div className="invoices-container">
      <h2 className="invoices-title">
        <FaFileInvoiceDollar style={{ marginRight: '10px' }} /> {isEnglish ? 'My invoices' : 'Mes factures'}
      </h2>
      {invoices.length === 0 ? (
        <p className="invoices-empty">{isEnglish ? 'No invoices are available yet.' : 'Aucune facture disponible.'}</p>
      ) : (
        <table className="invoice-table">
          <thead>
            <tr>
              <th>{isEnglish ? 'Service' : 'Service'}</th>
              <th><FaCalendarAlt /> {isEnglish ? 'Date' : 'Date'}</th>
              <th><FaDollarSign /> {isEnglish ? 'Amount' : 'Montant'}</th>
              <th>{isEnglish ? 'Status' : 'Statut'}</th>
              <th><FaReceipt /> {isEnglish ? 'Receipt' : 'Recu'}</th>
              <th>{isEnglish ? 'Billing details' : 'Facturation'}</th>
            </tr>
          </thead>
          <tbody>
            {invoices.map(inv => (
              <tr key={inv.invoice_id}>
                <td>{inv.service_name}</td>
                <td>{new Date(inv.start_time).toLocaleString(isEnglish ? 'en-CA' : 'fr-CA')}</td>
                <td>{(inv.amount_cents / 100).toFixed(2)} {inv.currency}</td>
                <td className={`status-${inv.status}`}>
                  {inv.status === 'paid' ? <span><FaCheckCircle color="green" /> {formatCareLabel(inv.status, isEnglish ? 'en' : 'fr')}</span> :
                   inv.status === 'failed' ? <span><FaTimesCircle color="red" /> {formatCareLabel(inv.status, isEnglish ? 'en' : 'fr')}</span> :
                   inv.status === 'draft' ? <span><FaHourglassHalf color="orange" /> {formatCareLabel(inv.status, isEnglish ? 'en' : 'fr')}</span> :
                   formatCareLabel(inv.status, isEnglish ? 'en' : 'fr')}
                </td>
                <td>
                  {inv.receipt_url ? (
                    <a href={inv.receipt_url} target="_blank" rel="noopener noreferrer" className="receipt-link">
                      <FaReceipt /> {isEnglish ? 'View receipt' : 'Voir recu'}
                    </a>
                  ) : '—'}
                </td>
                <td>
                  {inv.billing_name && inv.billing_email ? (
                    <div className="billing-info">
                      <strong>{inv.billing_name}</strong><br />
                      <FaEnvelope /> {inv.billing_email}<br />
                      <FaPhone /> {inv.billing_phone || '—'}<br />
                      <FaHome /> {inv.billing_address || '—'}
                    </div>
                  ) : (
                    '—'
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default MesFactures;
